import { render, staticRenderFns } from "./CreateNewPurchase.vue?vue&type=template&id=623182a2&scoped=true&"
import script from "./CreateNewPurchase.vue?vue&type=script&lang=js&"
export * from "./CreateNewPurchase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623182a2",
  null
  
)

export default component.exports